import { Text, Rating } from '@treatwell/ui';
import React, { PureComponent, ReactNode } from 'react';
import styles from './VenueSummary.module.css';

interface Props {
  name: string;
  address: string[];
  rating?: string;
  reviewCountText: string;
  goToVenueCta?: {
    label: string;
    url: string;
    onClick: (event: React.MouseEvent) => void;
    venueId: string;
  };
}

export class VenueSummary extends PureComponent<Props> {
  private onCta = async (event: React.MouseEvent): Promise<void> => {
    if (!this.props.goToVenueCta) {
      return;
    }

    this.props.goToVenueCta.onClick(event);
  };

  public render(): ReactNode {
    return (
      <div className={styles.summary}>
        {this.props.goToVenueCta ? (
          <a
            href={this.props.goToVenueCta.url}
            className={styles.venueLink}
            onClick={this.onCta}
          >
            <h3 className={styles.name}>
              {/*
                  React will render the name and the CTA without any intervening whitespace.
                  While this is usually not of much interest, in this case it is important.
                  It ensures the the last word of the name and the first word of the CTA
                  will be treated as a single word for wrapping purposes.
                  Futhermore the CTA is styled with "white-space: nowrap;".

                  The net effect is that the last word of the name along with the whole of
                  the CTA will be treated as a single unit, and will not be split when wrapping.
                */}
              {this.props.name}
              <span className={styles.cta}>
                {this.props.goToVenueCta.label}
              </span>
            </h3>
          </a>
        ) : (
          <h3 className={styles.name}>{this.props.name}</h3>
        )}

        <div className={styles.ratingContainer}>
          {this.props.rating !== undefined && this.props.rating !== '0.0' && (
            <div className={styles.rating}>
              <Rating rating={this.props.rating} size={24} showRatingValue />
            </div>
          )}
          <Text type="body" className={styles.ratingLabel}>
            {this.props.reviewCountText}
          </Text>
        </div>

        <div className={styles.addressCta}>
          <div className={styles.address}>
            {this.props.address.map((line, index) => (
              <div key={index} className={styles.addressLine}>
                {line}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
